import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import {
    ACCOUNTS_ROUTE,
    ACCOUNT_DETAIL_ROUTE,
    DASHBOARD_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    LOGIN_ROUTE,
    PAYMENTS_ROUTE,
    RESET_PASSWORD_ROUTE,
    SIGNUP_ROUTE,
    SET_PASSWORD_ROUTE,
    SUBSCRIPTION_ROUTE,
    SUBSCRIPTION_PLANS_ROUTE,
    VERIFICATIONS_ROUTE,
} from "@/router/routes";
import { ifNotAuthDeny } from "@/router/guards/not_auth";
import { ifAuthDeny } from "@/router/guards/auth";
import DashboardView from "@/views/Dashboard.vue";
import LoginView from "@/views/auth/Login.vue";
import SignupView from "@/views/auth/Signup.vue";
import ForgotPasswordView from "@/views/auth/Forgot_Password.vue";
import SetPasswordView from "@/views/auth/Set_Password.vue";
import AccountsView from "@/views/Accounts.vue";
import AccountDetailView from "@/views/Account_Detail.vue";
import VerificationsView from "@/views/Verifications.vue";
import SubscriptionsView from "@/views/Subscription.vue";
import SubscriptionPlansView from "@/views/Subscription_Plans.vue";
import PaymentsView from "@/views/Payments.vue";
import { redirectOn404 } from "./404_handler";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: DASHBOARD_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: DashboardView,
    },
    {
        path: "/login",
        name: LOGIN_ROUTE,
        beforeEnter: ifAuthDeny,
        component: LoginView,
    },
    {
        path: "/signup",
        name: SIGNUP_ROUTE,
        beforeEnter: ifAuthDeny,
        component: SignupView,
    },
    {
        path: "/forgot-password",
        name: FORGOT_PASSWORD_ROUTE,
        beforeEnter: ifAuthDeny,
        component: ForgotPasswordView,
    },
    {
        // Reset password from the "forgot password" email link.
        path: "/reset-password/:token",
        name: RESET_PASSWORD_ROUTE,
        beforeEnter: ifAuthDeny,
        component: SetPasswordView,
    },
    {
        // Staff invite: set initial password and verify email.
        path: "/set-password/:token",
        name: SET_PASSWORD_ROUTE,
        beforeEnter: ifAuthDeny,
        component: SetPasswordView,
    },
    {
        path: "/accounts",
        name: ACCOUNTS_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: AccountsView,
    },
    {
        // Account detail: overview / verifications / subscription / settings.
        path: "/accounts/:id",
        name: ACCOUNT_DETAIL_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: AccountDetailView,
    },
    {
        path: "/verifications",
        name: VERIFICATIONS_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: VerificationsView,
    },
    {
        path: "/subscriptions",
        name: SUBSCRIPTION_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: SubscriptionsView,
    },
    {
        path: "/subscription-plans",
        name: SUBSCRIPTION_PLANS_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: SubscriptionPlansView,
    },
    {
        path: "/payments",
        name: PAYMENTS_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: PaymentsView,
    },
    {
        path: '/:pathMatch(.*)*',
        beforeEnter: redirectOn404,
        component: DashboardView,
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
